import { render, staticRenderFns } from "./edit-shape.vue?vue&type=template&id=0d798d6b&scoped=true&"
import script from "./edit-shape.vue?vue&type=script&lang=js&"
export * from "./edit-shape.vue?vue&type=script&lang=js&"
import style0 from "./edit-shape.vue?vue&type=style&index=0&id=0d798d6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d798d6b",
  null
  
)

export default component.exports